import { render } from "./TokuAutodebitBanner.vue?vue&type=template&id=ac1b9d06&scoped=true&ts=true"
import script from "./TokuAutodebitBanner.vue?vue&type=script&lang=ts"
export * from "./TokuAutodebitBanner.vue?vue&type=script&lang=ts"

import "./TokuAutodebitBanner.vue?vue&type=style&index=0&id=ac1b9d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1b9d06"]])

export default __exports__